import PostList from '../../components/post/post-list';
import {  useNavigate } from 'react-router-dom';
import { getToken } from '../../storage/LocalStorageService';
import { useEffect } from 'react';

const PostHistory = () => {

  const {access_token} = getToken()
  const navigate = useNavigate();

  useEffect(() => {
    if (!access_token) {
      navigate("/auth/login");
    }
  }, [access_token, navigate]);
  

  return (
    <div className="container">
      <PostList endpoint="/post/get-user-history/" />
    </div>
  );
};

export default PostHistory;